import { Injectable } from '@angular/core';

import { TableRepository } from '@database/workspace';
import { TableModel } from '@shared';
import { Observable, of } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';
import { QueryParamsProvider } from '../../routing/services/query-params.provider';
import { TableTypeProvider } from '../services';
import { SamplesTableProvider } from './samples-table.provider';

@Injectable()
export class SamplesTableResolver {
	public constructor(
		private tableRepository: TableRepository,
		private samplesTableProvider: SamplesTableProvider,
		private queryParamsProvider: QueryParamsProvider,
		private tableTypeProvider: TableTypeProvider
	) {}

	public resolve(): Observable<void> {
		return this.tableRepository.getTableChildIdsByName$(this.queryParamsProvider.parentTableName).pipe(
			switchMap((childTableIds: number[] | null) =>
				// todo: use TableTypeProvider.getTableType()
				this.tableTypeProvider
					.isFlatSamplesTable$(this.queryParamsProvider.workfileId, this.queryParamsProvider.parentTableName)
					.pipe(
						first(),
						switchMap((isFlatSamples: boolean) => {
							if (isFlatSamples) {
								this.samplesTableProvider.samplesTableName = this.queryParamsProvider.parentTableName;
								return of(null);
							}

							return childTableIds !== null
								? this.tableRepository.getChildTablesMetadataByIds$(childTableIds).pipe(
										map((childTables: TableModel[]) => {
											const samplesTable: TableModel = childTables.find(
												(childTable: TableModel) =>
													this.tableTypeProvider.isSampleTable(
														childTable.table_name.toLowerCase()
													)
											);

											if (samplesTable) {
												this.samplesTableProvider.samplesTableName = samplesTable.table_name;
											}
										})
								  )
								: of(null);
						})
					)
			),
			first()
		);
	}
}
